import React, { useState } from 'react';
import { Button, Table, Form, Badge, Card } from 'react-bootstrap';
import SimpleControlGestionLayout from '../components/SimpleControlGestionLayout';
import { useGuias } from '../../Mantenedores/hooks/useGuias';
import * as FaIcons from 'react-icons/fa';

const BusquedaMasivaGuias = () => {
  const { handleGetGuias, guias, loading, error, success } = useGuias();
  const [inputValue, setInputValue] = useState('');
  const [guiasList, setGuiasList] = useState([]);

  const getEstadoColor = (estado) => {
    switch (estado?.toLowerCase()) {
      case 'delivered': return 'success';
      case 'not_delivered': return 'danger';
      case 'on_route': return 'warning';
      case 'create': return 'primary';
      default: return 'secondary';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const addGuia = (value) => {
    const trimmed = value.trim();
    if (trimmed && !guiasList.includes(trimmed)) {
      setGuiasList([...guiasList, trimmed]);
    }
    setInputValue('');
  };

  const removeGuia = (index) => {
    setGuiasList(guiasList.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addGuia(inputValue);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text');
    const newGuias = paste.split(/[\n,]+/).map(g => g.trim()).filter(g => g && !guiasList.includes(g));
    setGuiasList([...guiasList, ...newGuias]);
  };

  const handleSearch = () => {
    if (guiasList.length > 0) {
      const params = { 
        guias_bulk: guiasList.join(','),
        pageSize: guiasList.length,
        pageNumber: 1
      };
      handleGetGuias(params);
    }
  };

  return (
    <SimpleControlGestionLayout
      title="Búsqueda Masiva de Guías"
      subtitle="Busca múltiples guías mediante códigos de barras o QR"
      icon={<FaIcons.FaSearch />}
      iconColor="#ff9500"
      showBackButton={false}
    >
      <Form.Group className="mb-3">
        <Form.Label>Ingrese los códigos de guías (presione Enter o pegue múltiples separados por coma o enter)</Form.Label>
        <Form.Control
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          placeholder="Escanee o ingrese códigos de guías"
        />
      </Form.Group>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        maxHeight: '200px',
        overflowY: guiasList.length > 10 ? 'auto' : 'visible',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        padding: '8px',
        minHeight: '40px'
      }}>
        {guiasList.map((guia, index) => (
          <span key={index} style={{
            backgroundColor: '#e9ecef',
            padding: '4px 8px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            {guia}
            <button
              onClick={() => removeGuia(index)}
              style={{
                background: 'none',
                border: 'none',
                color: '#6c757d',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              ×
            </button>
          </span>
        ))}
      </div>
      <Button
        onClick={handleSearch}
        disabled={loading || guiasList.length === 0}
        className="mt-3 me-2"
      >
        {loading ? 'Buscando...' : 'Buscar Guías'}
      </Button>
      <Button
        onClick={() => setGuiasList([])}
        disabled={guiasList.length === 0}
        variant="outline-secondary"
        className="mt-3"
      >
        Limpiar Todo
      </Button>
      {error && <div className="alert alert-danger mt-3">{error}</div>}
      {success && <div className="alert alert-success mt-3">{success}</div>}
      {guias.length > 0 && (
        <div className="mt-4">
          <Card>
            <Card.Header>
              <h5 className="mb-0">
                <FaIcons.FaList className="me-2" />
                Resultados de Búsqueda ({guias.length} guías encontradas)
              </h5>
            </Card.Header>
            <Card.Body className="p-0">
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Guía</th>
                    <th>Cliente</th>
                    <th>Centro Despacho</th>
                    <th>Destinatario</th>
                    <th>Ruta Actual</th>
                    <th>Estado Actual</th>
                    <th>Fecha Creación</th>
                  </tr>
                </thead>
                <tbody>
                  {guias.map((guia, index) => (
                    <tr key={index}>
                      <td>
                        <strong>{guia.guia}</strong>
                        <br />
                        <small className="text-muted">ID: {guia.guia_id}</small>
                      </td>
                      <td>{guia.cliente?.cliente}</td>
                      <td>{guia.centro_despacho?.centro_despacho}</td>
                      <td>
                        {guia.destinatario?.nombre}
                        <br />
                        <small className="text-muted">{guia.destinatario?.comuna}, {guia.destinatario?.region}</small>
                      </td>
                      <td>
                        {guia.ruta_actual?.ruta}
                        <br />
                        <small className="text-muted">{guia.ruta_actual?.ppu_vehiculo}</small>
                      </td>
                      <td>
                        <Badge bg={getEstadoColor(guia.ultimo_estado?.estado)}>
                          {guia.ultimo_estado?.sub_estado}
                        </Badge>
                        <br />
                        <small className="text-muted">
                          {formatDate(guia.ultimo_estado?.fecha_asignacion)}
                        </small>
                      </td>
                      <td>{formatDate(guia.created_date)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </div>
      )}
    </SimpleControlGestionLayout>
  );
};

export default BusquedaMasivaGuias;